{
  "familyId": "GET-VERH-SCHAAL",
  "questions": [
    {
      "id": "GET-VERH-SCHAAL-001",
      "familyId": "GET-VERH-SCHAAL",
      "module": "Getalbegrip",
      "tier": 10,
      "levelCode": "M7+",
      "skill": "verhoudingen",
      "subSkill": "verhoudingstabel",
      "questionType": "multiple_choice",
      "question": "In een klas zitten jongens en meisjes in de verhouding 3 : 5. Er zijn 15 jongens. Hoeveel meisjes zijn er?",
      "options": [
        "25",
        "20",
        "30",
        "15"
      ],
      "correctAnswer": 0,
      "conceptId": "ratio_calculation",
      "variantIndex": 1,
      "stimulusAids": [
        {
          "type": "ratio",
          "data": {
            "headers": ["Jongens", "Meisjes"],
            "rows": [[3, 5], [15, "?"]],
            "label": "Verhoudingstabel: 3 : 5"
          }
        }
      ],
      "supportAids": [
        {
          "type": "ratio",
          "showWhen": "wrong",
          "data": {
            "headers": ["Jongens", "Meisjes"],
            "rows": [[3, 5], [15, "?"]],
            "highlight": [1, 1],
            "annotations": [
              {"row": 0, "col": 0, "text": "×5"},
              {"row": 0, "col": 1, "text": "×5"}
            ],
            "label": "Stap 1: 15 ÷ 3 = 5 (factor). Stap 2: 5 × 5 = 25 meisjes"
          }
        }
      ],
      "group": 7,
      "feedback": {
        "explanationText": "Stap 1: zoek de factor. 15 jongens ÷ 3 (verhouding) = factor 5. Stap 2: pas de factor toe op meisjes. 5 (verhouding) × 5 (factor) = 25 meisjes. Controleer: 15 : 25 = 3 : 5. ✓",
        "distractorExplanations": {
          "0": "Goed! Factor = 15 ÷ 3 = 5. Meisjes = 5 × 5 = 25.",
          "1": "20 klopt niet. Je hebt misschien 15 + 5 = 20 berekend. Maar je moet de factor gebruiken: 15 ÷ 3 = 5, dan 5 × 5 = 25.",
          "2": "30 klopt niet. Je hebt misschien 15 × 2 = 30 berekend. Maar de verhouding is 3:5, niet 1:2. Factor = 15 ÷ 3 = 5, meisjes = 5 × 5 = 25.",
          "3": "15 is het aantal jongens, niet het aantal meisjes. De verhouding is 3:5 — meisjes zijn er meer dan jongens. Factor = 15 ÷ 3 = 5, meisjes = 5 × 5 = 25."
        }
      }
    },
    {
      "id": "GET-VERH-SCHAAL-002",
      "familyId": "GET-VERH-SCHAAL",
      "module": "Getalbegrip",
      "tier": 10,
      "levelCode": "M7+",
      "skill": "verhoudingen",
      "subSkill": "verhoudingstabel",
      "questionType": "multiple_choice",
      "question": "Op een kaart met schaal 1 : 10.000 is een afstand 3 cm. Hoe groot is de echte afstand?",
      "options": [
        "300 meter",
        "30 meter",
        "3.000 meter",
        "30 km"
      ],
      "correctAnswer": 0,
      "conceptId": "scale_map_reading",
      "variantIndex": 1,
      "stimulusAids": [
        {
          "type": "ratio",
          "data": {
            "headers": ["Kaart (cm)", "Echt (cm)"],
            "rows": [[1, 10000], [3, "?"]],
            "label": "Schaal 1 : 10.000"
          }
        }
      ],
      "supportAids": [
        {
          "type": "ratio",
          "showWhen": "wrong",
          "data": {
            "headers": ["Kaart (cm)", "Echt (cm)"],
            "rows": [[1, 10000], [3, "?"]],
            "highlight": [1, 1],
            "annotations": [
              {"row": 0, "col": 0, "text": "×3"},
              {"row": 0, "col": 1, "text": "×3"}
            ],
            "label": "Stap 1: 3 × 10.000 = 30.000 cm. Stap 2: 30.000 cm = 300 meter"
          }
        }
      ],
      "group": 7,
      "feedback": {
        "explanationText": "Stap 1: schaal 1:10.000 betekent 1 cm op de kaart = 10.000 cm in werkelijkheid. Stap 2: 3 cm op de kaart = 3 × 10.000 = 30.000 cm. Stap 3: omrekenen naar meters: 30.000 cm ÷ 100 = 300 meter.",
        "distractorExplanations": {
          "0": "Goed! 3 × 10.000 = 30.000 cm = 300 meter.",
          "1": "30 meter = 3.000 cm. Je hebt gedeeld door 10.000 in plaats van vermenigvuldigd. Schaal 1:10.000 betekent ×10.000: 3 × 10.000 = 30.000 cm = 300 m.",
          "2": "3.000 meter = 300.000 cm. Je hebt 3 × 100.000 berekend in plaats van 3 × 10.000. De schaal is 1:10.000, dus 3 × 10.000 = 30.000 cm = 300 m.",
          "3": "30 km = 3.000.000 cm. Dat is 100× te groot. De schaal is 1:10.000: 3 × 10.000 = 30.000 cm = 300 m (niet km)."
        }
      }
    },
    {
      "id": "GET-VERH-SCHAAL-003",
      "familyId": "GET-VERH-SCHAAL",
      "module": "Getalbegrip",
      "tier": 10,
      "levelCode": "M7+",
      "skill": "verhoudingen",
      "subSkill": "verhoudingstabel",
      "questionType": "ratio_table",
      "question": "Voor een recept heb je bloem en suiker nodig in de verhouding 4 : 1. Je gebruikt 200 gram bloem. Hoeveel suiker heb je nodig?",
      "options": [
        "50 gram",
        "200 gram",
        "100 gram",
        "25 gram"
      ],
      "correctAnswer": 0,
      "data": {
        "headers": ["Bloem (gram)", "Suiker (gram)"],
        "rows": [[4, 1], [200, null]],
        "missingCell": {"row": 1, "col": 1},
        "correctValue": 50
      },
      "conceptId": "ratio_recipe_calculation",
      "variantIndex": 3,
      "stimulusAids": [
        {
          "type": "ratio",
          "data": {
            "headers": ["Bloem (gram)", "Suiker (gram)"],
            "rows": [[4, 1], [200, "?"]],
            "label": "Recept verhouding 4 : 1"
          }
        }
      ],
      "supportAids": [
        {
          "type": "ratio",
          "showWhen": "wrong",
          "data": {
            "headers": ["Bloem (gram)", "Suiker (gram)"],
            "rows": [[4, 1], [200, 50]],
            "highlight": [1, 1],
            "annotations": [
              {"row": 0, "col": 0, "text": "×50"},
              {"row": 0, "col": 1, "text": "×50"}
            ],
            "label": "Stap 1: 200 ÷ 4 = 50 (factor). Stap 2: 1 × 50 = 50 gram suiker"
          }
        }
      ],
      "group": 7,
      "feedback": {
        "explanationText": "Stap 1: zoek de factor. 200 gram bloem ÷ 4 (verhouding) = factor 50. Stap 2: pas de factor toe op suiker. 1 (verhouding) × 50 (factor) = 50 gram suiker. Controleer: 200 : 50 = 4 : 1. ✓",
        "distractorExplanations": {
          "0": "Goed! Factor = 200 ÷ 4 = 50. Suiker = 1 × 50 = 50 gram.",
          "1": "200 gram is de hoeveelheid bloem, niet suiker. De verhouding is 4:1 — suiker is 4× minder dan bloem. Factor = 200 ÷ 4 = 50, suiker = 1 × 50 = 50 gram.",
          "2": "100 gram klopt niet. Je hebt misschien 200 ÷ 2 = 100 berekend (verhouding 2:1). Maar de verhouding is 4:1: factor = 200 ÷ 4 = 50, suiker = 50 gram.",
          "3": "25 gram klopt niet. Je hebt misschien 200 ÷ 8 = 25 berekend. Maar de factor is 200 ÷ 4 = 50, en suiker = 1 × 50 = 50 gram."
        }
      }
    },
    {
      "id": "GET-VERH-SCHAAL-004",
      "familyId": "GET-VERH-SCHAAL",
      "module": "Getalbegrip",
      "tier": 10,
      "levelCode": "M7+",
      "skill": "verhoudingen",
      "subSkill": "verhoudingstabel",
      "questionType": "ratio_table",
      "question": "Een auto rijdt 120 km in 2 uur. Hoeveel kilometer rijdt de auto in 5 uur (met dezelfde snelheid)?",
      "options": [
        "300 km",
        "240 km",
        "360 km",
        "250 km"
      ],
      "correctAnswer": 0,
      "data": {
        "headers": ["Tijd (uur)", "Afstand (km)"],
        "rows": [[2, 120], [5, null]],
        "missingCell": {"row": 1, "col": 1},
        "correctValue": 300
      },
      "conceptId": "ratio_speed_distance",
      "variantIndex": 4,
      "stimulusAids": [
        {
          "type": "ratio",
          "data": {
            "headers": ["Tijd (uur)", "Afstand (km)"],
            "rows": [[2, 120], [5, "?"]],
            "label": "Snelheid verhouding"
          }
        }
      ],
      "supportAids": [
        {
          "type": "ratio",
          "showWhen": "wrong",
          "data": {
            "headers": ["Tijd (uur)", "Afstand (km)"],
            "rows": [[2, 120], [5, 300]],
            "highlight": [1, 1],
            "annotations": [
              {"row": 0, "col": 0, "text": "÷2, dan ×5"},
              {"row": 0, "col": 1, "text": "÷2 = 60, dan ×5 = 300"}
            ],
            "label": "Stap 1: 120 ÷ 2 = 60 km/uur. Stap 2: 60 × 5 = 300 km"
          }
        }
      ],
      "group": 7,
      "feedback": {
        "explanationText": "Stap 1: bereken de snelheid per uur. 120 km ÷ 2 uur = 60 km per uur. Stap 2: bereken de afstand in 5 uur. 60 km/uur × 5 uur = 300 km.",
        "distractorExplanations": {
          "0": "Goed! 120 ÷ 2 = 60 km/uur. 60 × 5 = 300 km.",
          "1": "240 km klopt niet. Je hebt 120 × 2 = 240 berekend. Maar de auto rijdt 5 uur, niet 2×2=4 uur. Snelheid = 120 ÷ 2 = 60 km/uur, afstand = 60 × 5 = 300 km.",
          "2": "360 km klopt niet. Je hebt misschien 120 × 3 = 360 berekend. Maar de auto rijdt 5 uur: 60 km/uur × 5 = 300 km.",
          "3": "250 km klopt niet. Je hebt misschien 50 km/uur × 5 = 250 berekend. Maar de snelheid is 120 ÷ 2 = 60 km/uur, dus 60 × 5 = 300 km."
        }
      }
    }
  ]
}